<template>
  <div class="relative overflow-hidden bg-gradient-to-r from-accent/5 to-gradient-end/5 py-20 dark:from-accent/10 dark:to-gradient-end/10">
    <div class="container mx-auto px-6">
      <div class="mx-auto max-w-7xl">
        <div class="mb-16 text-center">
          <h2 class="mb-6 text-3xl font-bold text-ternary-dark dark:text-primary-light sm:text-4xl">
            {{ title }}
          </h2>
          <p class="mx-auto max-w-3xl text-lg text-gray-600 dark:text-gray-400">
            {{ description }}
          </p>
        </div>

        <div class="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          <div
            v-for="category in categories"
            :key="category.title"
            class="rounded-2xl bg-card-gradient p-8 shadow-soft dark:bg-card-gradient-dark"
          >
            <div class="mb-6 flex items-center">
              <div class="mr-4 flex size-12 items-center justify-center rounded-full bg-gradient-to-r from-accent to-gradient-end">
                <component :is="category.icon" class="size-6 text-white" />
              </div>
              <h3 class="text-xl font-bold text-ternary-dark dark:text-ternary-light">
                {{ category.title }}
              </h3>
            </div>
            <div class="flex flex-wrap gap-2">
              <span
                v-for="tech in category.technologies"
                :key="tech"
                class="rounded-full bg-gradient-to-r from-accent/10 to-gradient-end/10 px-3 py-1 text-sm font-medium text-ternary-dark dark:text-ternary-light"
              >
                {{ tech }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface TechnologyCategory {
  title: string
  icon: any
  technologies: string[]
}

interface Props {
  title: string
  description: string
  categories: TechnologyCategory[]
}

defineProps<Props>()
</script>
